import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EventService } from "../util/event/event-service";
import { GiftCardAlert } from "./model/gift-card-alert";
import { GiftCardCustomerOrder } from "./model/gift-card-customer-order";

@Injectable()
export class GiftCardAlertService extends EventService<GiftCardAlert[]>{

  constructor(private httpClient: HttpClient) {
    super(true);
  }

  public confirm(id: string): Observable<HttpResponse<void>> {
    return this.httpClient.post<HttpResponse<void>>(`/api/gift-card-alert/${id}?confirm`, {});
  }

  public findCustomerOrders(id: string): Observable<GiftCardCustomerOrder[]> {
    return this.httpClient.get<GiftCardCustomerOrder[]>(`/api/gift-card-alert/${id}`);
  }

  private findUnconfirmed(): Observable<GiftCardAlert[]> {
    return this.httpClient.get<GiftCardAlert[]>(`/api/gift-card-alert`)
  }

  refresh(): Observable<GiftCardAlert[]> {
    return this.findUnconfirmed();
  }
}